export default __webpack_public_path__ + "static/media/photo--lg--misc-25.785beb79.jpg";